import styled from 'styled-components';

const VideoPlayerLazy = styled.div`
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
`;

export default VideoPlayerLazy;
